import type { Setting } from "@prisma/client";
import Sqids from "sqids";

import type { GameMode } from "~/components/Game";

import { validateSqid } from "./sqids";

const sqids = new Sqids({
  minLength: 5,
  alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
});

export const getCodeForId = (assignmentId: number) =>
  sqids.encode([assignmentId]);

export const getIdForCode = (code: string) => validateSqid(sqids, code);

export const getGameModeFromSettings = (settings: Setting[]): GameMode => {
  if (settings.includes("PAIRS")) {
    return "pairs";
  }

  if (settings.includes("IMAGE_MATCH")) {
    return "imcq";
  }

  if (settings.includes("MULTIPLE_CHOICE")) {
    return "mcq";
  }

  return "classic";
};
